"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.M365EntityType = void 0;
var M365EntityType;
(function (M365EntityType) {
    M365EntityType["User"] = "User";
    M365EntityType["Group"] = "Group";
})(M365EntityType = exports.M365EntityType || (exports.M365EntityType = {}));
//# sourceMappingURL=interface.js.map